import { useFormikContext } from "formik";
import { isEmpty } from "lodash";

const ReportError = ({ message = "Enter text in each section and hit enter after each one." }) => {
  const { errors, touched } = useFormikContext();
  return (
    <div style={{ color: "#315D99" }} className="py-2">{!isEmpty(errors) && !isEmpty(touched) && message}</div>
  )
}

export default ReportError;

// There are errors in the form. Please check your entries and correct them.